<template>
  <error-content code="500" :desc="$t('pages_error_page_500_497')" :src="src" />
</template>

<script>
import i18n from '../../locales/index'

import error404 from '@/assets/images/error-page/error-500.svg'
import errorContent from './error-content.vue'
export default {
  name: 'error_500',
  components: {
    errorContent
  },
  data () {
    return {
      src: error404
    }
  }
}
</script>
